/**
 * Remove JWTs from localStorage — sessions use HttpOnly cookies.
 */
export function clearLegacyAuthTokens() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('token');
  localStorage.removeItem('superAdminToken');
}
